import {getCurrentUserId} from '@travel-frontend/user-id';
import {StrictMode} from 'react';
// eslint-disable-next-line sonarjs/deprecation, react/no-deprecated -- @todo we need to fix StrictMode warnings before hands
import {render} from 'react-dom';
import {RouterProvider} from 'react-router/dom';

import {router} from '@/Router';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

// before rendering the application make sure we have a userId
getCurrentUserId();

// eslint-disable-next-line sonarjs/deprecation -- @todo we need to fix StrictMode warnings before hands
render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
  rootElement
);
